export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const FORM_NAME = 'date-cargo-collection';

export const DATE_TIME_FORMAT = 'DD.MM.YYYY HH:mm:ss';

export const REQUIRED_FIELDS = ['fetch_at', 'fetch_time_from', 'fetch_time_to'];
